import { render, staticRenderFns } from "./WarrantyRegistration.vue?vue&type=template&id=1d283f03&scoped=true"
import script from "./WarrantyRegistration.vue?vue&type=script&lang=js"
export * from "./WarrantyRegistration.vue?vue&type=script&lang=js"
import style0 from "./WarrantyRegistration.vue?vue&type=style&index=0&id=1d283f03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d283f03",
  null
  
)

export default component.exports